<template>
  <Card class="stats-card">
    <i-circle :percent="currentCountPerc" :dashboard="true" style="">
        <span class="demo-Circle-inner" style="font-size:24px">{{currentCount}}</span>
    </i-circle>
    <div class="stats-title"><b>Concurrent Viewers</b></div>
    <div><router-link :to="'/wc/'+webcast._id+'/who_is_watching'">Who is watching</router-link></div>
  </Card>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy',
    }),
    ...mapGetters('registrations', {
      findRegistrationsInStore: 'find'
    }),
    ...mapGetters('realtime-stats', {
      statsInStore: 'find'
    }),
    regCount(){
      return this.findRegistrationsInStore({
        query: {
            $limit: 0,
            webcastId: this.webcast._id
        }
      }).total
    },
    currentCountPerc(){
      let hundered = ((this.currentCount/100)+1)*100;
      return (this.currentCount*100)/hundered;
    },
    currentCount(){
      var now = new Date();
      let query = {
        'webcastId': this.webcast._id,
        'sessionId': this.webcast.currentSessionId
      }

      console.log(query);
      var stats =  this.statsInStore({
        query: {
          'webcastId': this.webcast._id,
          'sessionId': this.webcast.currentSessionId
        }
      })

      let attCount = 0;
      let deviceCount = 0;


        if(this.pageSettings.registrationEnabled){
          _.forEach(stats.data, function(stat) {
            attCount += stat.concurrentAttendees
          });
          if(this.webcast.status == "live"){
            return attCount
          } else {
            return 0;
          }
        } else {
          _.forEach(stats.data, function(stat) {
            deviceCount += stat.concurrentDevices
          });
          if(this.webcast.status == "live"){
            return deviceCount
          } else {
            return 0;
          }
        }


    }
  },
  watch:{
  },
  methods: {
  }
}
</script>

<style>

</style>
